module.exports = __webpack_public_path__ + "media/images/sp/stores/kamakura/main-visual-text-09eeeb6625b009ff0d2ca9dc4ebf5f0d.png";